export default __webpack_public_path__ + "static/media/misc-books3-480w.25c94ad2.webp";